import {useRef} from 'react'

/**
 * The previous array while the new one has the same items in the same order. Callers often pass
 * Object.values(...) or a new filtered array on every render, this keeps memos on the rows from running again.
 */
export default function useStableArray<T>(array: T[]): T[] {
    const ref = useRef(array)
    const previous = ref.current

    if (previous !== array && (previous.length !== array.length || array.some((item, index) => item !== previous[index]))) {
        ref.current = array
    }

    return ref.current
}
